import React, {useState, useEffect} from "react";
import Button from "../../components/Button";
import {withTranslation} from "react-i18next";
import ToggleWithLabel from "../../components/ToggleWithLabel";
import {createFilling} from "../../services/fillingService";
import {useSelector} from "react-redux/es/exports";
import {useNavigate, useParams} from "react-router-dom";
import {getListFunc} from "../../services/fillingService";
import {MdOutlineDataSaverOff} from "react-icons/md";
import {toast} from "react-toastify";


const AddFilling = ({t}) => {
    const [name, setName] = useState("");
    const [clearance, setClearance] = useState("");
    const [isInner, setIsInner] = useState(false);
    const [isOuter, setIsOuter] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const {token} = useSelector((state) => state.user);
    const navigate = useNavigate();
    const {id} = useParams();

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        setIsLoading(true);
        const response = await createFilling(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/filling/group`,
            token,
            {
                id: id ? id : null,
                name: evt.target.name.value,
                clearance: evt.target.clearance.value,
                outer: isOuter,
                inner: isInner,
            }
        );
        if (response.success) {
            setIsLoading(false);
            navigate("/filling");
            toast.success(id ? t('action.edit_success') : t('action.add_success'), {
                position: "bottom-right",
                autoClose: 3000,
                closeOnClick: true,
                className: "add-success"
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    const getData = async (id) => {
        const response = await getListFunc(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/filling/group/${id}`,
            token
        );
        if (response.success) {
            setIsInner(response.data.inner);
            setIsOuter(response.data.outer);
            setName(response.data.name);
            setClearance(response.data.clearance);
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (id) {
            getData(id);
        }
    }, [id]);

    return (
        <div className="px-4 py-4 sm:px-6 lg:px-8">
            <h1 className="mb-5 text-xl font-semibold text-gray-900">
                {id ? t(`update_filling`) : t(`add_filling`)}
            </h1>
            <form onSubmit={handleSubmit}>
                <div className="shadow sm:overflow-hidden sm:rounded-md">
                    <div className="px-4 py-6 space-y-6 bg-white sm:p-6">
                        <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-3">
                                <label
                                    htmlFor="first-name"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    {t('name')}
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    id="first-name"
                                    autoComplete="given-name"
                                    className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                    defaultValue={name}
                                    required
                                />
                            </div>
                            <br/>
                            <div className="col-span-6 sm:col-span-3">
                                <label
                                    htmlFor="clearance"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    {t('clearance')}
                                </label>
                                <input
                                    type="number"
                                    name="clearance"
                                    id="clearance"
                                    autoComplete="clearance"
                                    className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                    defaultValue={clearance}
                                    required
                                />
                            </div>
                            <br/>
                            <div className="col-span-6 sm:col-span-3 flex justify-between items-center">
                                <ToggleWithLabel
                                    label={t('outer')}
                                    enabled={isOuter}
                                    setEnabled={setIsOuter}
                                />
                                <ToggleWithLabel
                                    label={t('inner')}
                                    enabled={isInner}
                                    setEnabled={setIsInner}
                                />
                            </div>
                            <div className="col-span-6 sm:col-span-3">

                            </div>
                        </div>
                    </div>
                    <div className="flex items-center justify-end px-4 py-3 text-right bg-gray-50 sm:px-6">
                        <Button type="button" to="/filling" btnName={t(`backward`)}/>
                        <button
                            type="submit"
                            className="text-white bg-blue-700 hover:bg-blue-800  font-medium rounded-lg text-sm px-5 py-1.5 text-center  dark:bg-blue-600 dark:hover:bg-blue-700  inline-flex items-center"
                        >
                            {t(`save`)}
                            {isLoading ? (
                                <svg
                                    role="status"
                                    className="inline w-4 h-4 ml-1 text-white animate-spin"
                                    viewBox="0 0 100 101"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="#E5E7EB"
                                    />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            ) : (
                                <MdOutlineDataSaverOff className="w-4 h-4 ml-1"/>
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default withTranslation()(AddFilling);
